import React from "react";
import Select from "react-select";
import { onlyNumericInput } from "@/utils";
import { businessTypeOptions, businessStatusOptions } from "@/constants/selectOptions";

export const BusinessInfo = ({ formData, handleChange, setFormData, getFileName, handleCommonFileChange, disabled }) => {
    const { contractBusinessInfo } = formData;

    return (
        <>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        사업자 이름 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            placeholder=""
                            name="contractBusinessInfo.corpName"
                            value={contractBusinessInfo?.corpName || ""}
                            onChange={handleChange}
                            disabled={disabled}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        사업자 번호 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            placeholder=""
                            name="contractBusinessInfo.bizNumber"
                            value={contractBusinessInfo?.bizNumber || ""}
                            onChange={handleChange}
                            disabled={disabled}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3"></div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        담당자 이름 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            placeholder=""
                            name="contractBusinessInfo.managerName"
                            value={contractBusinessInfo?.managerName || ""}
                            onChange={handleChange}
                            disabled={disabled}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        담당자 연락처 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            placeholder=""
                            name="contractBusinessInfo.managerPhone"
                            value={contractBusinessInfo?.managerPhone || ""}
                            onChange={handleChange}
                            onInput={onlyNumericInput}
                            maxLength={11}
                            disabled={disabled}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>이메일</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            placeholder=""
                            name="contractBusinessInfo.email"
                            value={contractBusinessInfo?.email || ""}
                            onChange={handleChange}
                            disabled={disabled}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="1">
                <div className="row-head">
                    <span>
                        사업자 주소 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element" style={{ display: "none" }}>
                        <input
                            type="text"
                            placeholder=""
                            name="contractBusinessInfo.bCode"
                            value={contractBusinessInfo?.bCode}
                            onChange={handleChange}
                            readOnly
                            onClick={() => {
                                setFormData((prevState) => ({
                                    ...prevState,
                                    addressPopupStatus: true,
                                    addressPopupTarget: "BUSINESS",
                                }));
                            }}
                            disabled={disabled}
                        />
                    </div>
                    <div className="form-element" style={{ width: "668px" }}>
                        <input
                            type="text"
                            placeholder=""
                            name="contractBusinessInfo.address"
                            value={contractBusinessInfo?.address}
                            onChange={handleChange}
                            readOnly
                            onClick={() => {
                                setFormData((prevState) => ({
                                    ...prevState,
                                    addressPopupStatus: true,
                                    addressPopupTarget: "BUSINESS",
                                }));
                            }}
                            disabled={disabled}
                        />
                    </div>
                    <div className="form-element">
                        <input
                            type="text"
                            placeholder="상세 주소를 입력해주세요."
                            name="contractBusinessInfo.addressDetail"
                            value={contractBusinessInfo?.addressDetail}
                            onChange={handleChange}
                            disabled={disabled}
                        />
                    </div>
                    {!disabled && (
                        <div className="form-element_button">
                            <button
                                type="button"
                                className="btn-form_element btn-outline"
                                onClick={() => {
                                    setFormData((prevState) => ({
                                        ...prevState,
                                        addressPopupStatus: true,
                                        addressPopupTarget: "BUSINESS",
                                    }));
                                }}
                                disabled={disabled}
                            >
                                주소검색
                            </button>
                        </div>
                    )}
                </div>
            </div>

            <div className="item-row" data-grow="1">
                <div className="row-head">
                    <span>
                        사업자등록증 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            readOnly
                            value={getFileName("BIZ_LIC")}
                            placeholder="4MB 이하 PDF 파일로 첨부해주세요."
                            onClick={() => {
                                const uploadItem = formData.contractUploads?.find((item) => item.uploadType === "BIZ_LIC");
                                if (uploadItem && uploadItem.upload && uploadItem.upload.url) {
                                    window.open(uploadItem.upload.url, "_blank");
                                } else {
                                    document.getElementById("bizLicenseInput").click();
                                }
                            }}
                            disabled={disabled}
                        />
                    </div>
                    {!disabled && (
                        <div className="form-element_button">
                            <button
                                type="button"
                                className="btn-form_element btn-outline"
                                onClick={() => document.getElementById("bizLicenseInput").click()}
                                disabled={disabled}
                            >
                                파일첨부
                            </button>
                            <input
                                type="file"
                                id="bizLicenseInput"
                                style={{ display: "none" }}
                                accept=".pdf,.jpg,.png"
                                onChange={(e) => handleCommonFileChange(e, "BIZ_LIC")}
                            />
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};
